///<reference path="strategy-base.ts"/>

module Meevo.Components.Controls.HideInput {

    export class StrategyAdd extends StrategyBase implements ITextChangeStrategy {
        getActualValue(selectionStart: number, selectionEnd: number): string {
            return this.actualValue.substring(0, selectionStart) + this.data + this.actualValue.substring(selectionEnd);
        }
    }
}
